




















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import LayoutTitle from '@/components/LayoutTitle.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import ScrollWrapper from '@/components/ScrollbarWrapper.vue';
import api from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import {
  GroupWithPermissions, PermissionApiResponse, GroupApiResponse, GroupPermissionApiReponse,
} from '@/libs/api.interfaces';

@Component({
  components: {
    LayoutTitle,
    Select,
    FormInput,
    SearchIcon,
    LayoutContent,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    ScrollWrapper,
  },
})
export default class GroupManagement extends Vue {
  searchCategory = '';
  search = '';
  loading = true;
  permissions: PermissionItem[] = [];
  groups: GroupWithPermissions[] = [];

  get type() {
    return this.$route.params.type;
  }

  mounted() {
    this.getPermissions();
  }

  @Watch('$route')
  onRouterChanged() {
    this.getPermissions();
  }

  isAllowed(id: number, permission: string) {
    const group = this.groups.find((g) => g.id === id);
    if (group) {
      return group.permissions.find((p) => p === permission) !== undefined;
    }

    return false;
  }

  private async getPermissions() {
    try {
      this.loading = true;
      const { data } = await api.get<PermissionApiResponse>('/permissions', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_internal: this.$route.params.type === 'internal',
        },
      });
      const permissions = data.data;
      if (permissions) {
        this.permissions = permissions;
      }

      this.getGroups();
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to get permission list');
    }
  }

  private async getGroups() {
    try {
      const { data } = await api.get<GroupApiResponse>('/user-groups');
      const groups = data.data.items;
      this.groups = (groups as GroupWithPermissions[])
        .filter((g) => g.is_internal === (this.type === 'internal' ? 1 : 0));

      await Promise.all(this.groups.map((group) => this.getGroupPermission(group.id)));

      this.loading = false;
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to get group list');
    }
  }

  private async getGroupPermission(id: number) {
    try {
      const { data } = await api.get<GroupPermissionApiReponse>(`/user-group/${id}/permissions`);
      const groupIndex = this.groups.findIndex((e) => e.id === id);
      this.groups[groupIndex].permissions = data.data.permission;
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to get group permissions');
    }
  }
}
